// extracted by mini-css-extract-plugin
export default {"container":"tG-z","header":"uG-z","details":"vG-z","link":"wG-z"};